import {
  Stack,
  Button,
  RadioGroup,
  FormControlLabel,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

import { useCheckout } from "../CheckoutContext";
import SquareRadio from "./SquareRadio";

export default function ShippingStep() {
  const {
    checkoutData,
    updateSection,
    nextStep,
    prevStep,
    shippingOptions,
    loadingShipping,
  } = useCheckout();

  const selected = checkoutData.shipping.method;
  const isValid = Boolean(selected);

  function handleSelect(option) {
    updateSection("shipping", {
      method: option.method,
      price: option.price,
      prazo: option.prazo,
      carrier: option.carrier,
    });
  }

  return (
    <Stack spacing={3}>
      <Typography variant="h6">Escolha o frete</Typography>

      {loadingShipping && (
        <Box textAlign="center">
          <CircularProgress />
          <Typography variant="body2" mt={1}>
            Calculando opções de frete…
          </Typography>
        </Box>
      )}

      {!loadingShipping && shippingOptions.length === 0 && (
        <Typography color="error">
          Nenhuma opção de frete disponível para este CEP.
        </Typography>
      )}

      <RadioGroup value={selected}>
        {shippingOptions.map((opt) => (
          <Box
            key={opt.id}
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: 2,
              px: 2,
              py: 1.5,
              mb: 1,
              transition: "border 0.15s ease",
              "&:has(input:checked)": {
                borderColor: "#1e293b",
              },
            }}
          >
            <FormControlLabel
              value={opt.method}
              control={<SquareRadio />}
              onChange={() => handleSelect(opt)}
              label={`${opt.carrier} — R$ ${opt.price.toFixed(
                2
              )} (${opt.prazo})`}
              sx={{ width: "100%" }}
            />
          </Box>
        ))}
      </RadioGroup>

      <Stack spacing={2}>
        <Button variant="outlined" onClick={prevStep}>
          Voltar
        </Button>

        <Button
          variant="contained"
          disabled={!isValid}
          onClick={nextStep}
        >
          Continuar
        </Button>
      </Stack>
    </Stack>
  );
}